var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.content === 'yes')?[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("done ")])]:(_vm.content === 'no')?[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("clear ")])]:[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }